module.exports = __webpack_public_path__ + "static/media/home.3c8c87c8.jpg";